(ns practitest.frontend.components.grid.sessionstorage
  (:require [practitest.frontend.common.dom :as dom]
            [practitest.frontend.subs :as subs]
            [re-frame.core :as re-frame]))


(defn- sort-order-key [table-id]
  (when table-id
    (str table-id "-sort-order")))

(defn load-sort-order
  [table-id]
  (when-let [key (sort-order-key table-id)]
    (try
      (cljs.reader/read-string (dom/get-session-item key))
      (catch js/Error e
        (js/console.warn e)))))

(defn save-sort-order
  [table-id sort-order]
  (when-let [key (sort-order-key table-id)]
    (if (nil? sort-order)
      (dom/remove-session-item key)
      (dom/set-session-item key (pr-str sort-order)))))

(defn- autofilters-key [table-id]
  (when table-id
    (str table-id "-autofilters")))

(defn save-autofilters
  [table-id autofilters]
  (when-let [key (autofilters-key table-id)]
    (if (nil? autofilters)
      (dom/remove-session-item key)
      (dom/set-session-item key (pr-str autofilters)))))

(defn load-autofilters
  [table-id]
  (when-let [key (autofilters-key table-id)]
    (try
      (cljs.reader/read-string (dom/get-session-item key))
      (catch js/Error e
        (js/console.warn e)))))

(defn- per-page-key [table-id]
  (when table-id
    (str table-id "-per-page")))

(defn load-per-page
  [table-id]
  (when-let [key (per-page-key table-id)]
    (try
      (cljs.reader/read-string (dom/get-session-item key))
      (catch js/Error e
        (js/console.warn e)))))

(defn save-per-page
  [table-id per-page]
  (when-let [key (per-page-key table-id)]
    (if (nil? per-page)
      (dom/remove-session-item key)
      (dom/set-session-item key (pr-str per-page)))))

(defn- traceability-scope-key [user-id requirement-id]
  (str "requirement-traceability-scope-" user-id "-" requirement-id))

(defn save-traceability-scope [scope requirement-id]
  (let [current-user @(re-frame/subscribe [::subs/current-user])
        user-id      (:id current-user)
        key          (traceability-scope-key user-id requirement-id)]
    (dom/set-session-item key (pr-str scope))))

(defn load-traceability-scope [requirement-id]
  (let [current-user @(re-frame/subscribe [::subs/current-user])
        user-id      (:id current-user)
        key          (traceability-scope-key user-id requirement-id)]
    (try
      (when-let [stored-value (dom/get-session-item key)]
        (keyword (cljs.reader/read-string stored-value)))
      (catch js/Error e
        (js/console.warn e)
        :test))))
